//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum UserRoleEnum {
	Guest = 0,
	User = 1,
	Technician = 10,
	OutsideSales = 20,
	OutsideSalesExternal = 21,
	SetterExternal = 22,
	TechnicianExternal = 23,
	InsideSales = 30,
	BranchManager = 49,
	DoorToDoor = 50,
	D2DManager = 59,
	CustomerService = 60,
	RegionalManager = 69,
	ServiceManager = 79,
	SalesAdmin = 89,
	Admin = 99,
	SupportStaff = 999,
	SuperAdmin = 9999
}
